import * as React from 'react';
import { SVGProps } from 'react';

const SvgJacket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M7 35v-1.147c.061-2.287.301-4.566.718-6.815.286-1.746 2.038-12.793 2.038-12.917l.061-.382 1.529-1.679a1.314 1.314 0 0 0 .25-1.343l-.571-1.478L12.4 4h6.068v1.292c0 .685.268 1.342.746 1.826a2.53 2.53 0 0 0 1.801.757 2.53 2.53 0 0 0 1.802-.757 2.602 2.602 0 0 0 .746-1.826V4h6.062l1.432 5.322-.805 1.55c-.15.288-.188.622-.106.937.082.315.278.587.55.763l1.527.976 2.232 13.232c.363 1.959.546 3.948.545 5.941V34.8H20M18.5 4h5M21 8v27"
    />
    <path fill={props.fill} d="M5.625 35.557H20.3V30.35h-9.442l-5.233 5.207Z" />
    <path
      fill="currentColor"
      d="M25.163 21.294a1.302 1.302 0 1 0 0-2.604 1.302 1.302 0 0 0 0 2.604Z"
    />
  </svg>
);

export default SvgJacket;
